// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeepLinkAliasField__container-e3822b {
  display: block;
}

.DeepLinkAliasField__title-a991ba {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
  margin-bottom: 4px;
}

.DeepLinkAliasField__description-f067fa {
  font: var(--font-subtitle-4);
  letter-spacing: var(--font-spacing-subtitle-4);
  color: var(--base-80);
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/DeepLinkAliasField/DeepLinkAliasField.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,4BAAA;EACA,8CAAA;EACA,qBAAA;EACA,mBAAA;AACF","sourcesContent":[".container {\n  display: block;\n}\n\n.title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n  margin-bottom: 4px;\n}\n\n.description {\n  font: var(--font-subtitle-4);\n  letter-spacing: var(--font-spacing-subtitle-4);\n  color: var(--base-80);\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DeepLinkAliasField__container-e3822b`,
	"title": `DeepLinkAliasField__title-a991ba`,
	"description": `DeepLinkAliasField__description-f067fa`
};
module.exports = ___CSS_LOADER_EXPORT___;
